import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/rootReducer";

export type ModalStatus = "modal" | "form" | "hide" | "edit" | "add";

interface FormConfig {
  onSubmit?: (data: any) => void;
  defaultValues?: any;
  submitText?: string;
}
interface ModalProps {
  name?: string;
  status?: any;
  key?: any;
  onClose?: (name: string) => void;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  header?: React.ReactNode;
  outerClassName?: string;
  form?: FormConfig;
  formLoading?: boolean;
  data?: any;
  url?: string | null;
}

const initialState: ModalProps & { quoteKey: number; stepIndex: number } = {
  name: "",
  status: "hide",
  onClose: () => {},
  title: "",
  children: null,
  className: "",
  header: undefined,
  outerClassName: "",
  quoteKey: 0,
  stepIndex: 1,
  form: {
    onSubmit: null,
    defaultValues: null,
    submitText: "",
  },
  formLoading: false,
  data: null,
  url: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openModal(state, action: { payload: ModalProps }) {
      state.name = action.payload.name;
      state.status = action.payload.status || "modal";
      state.onClose = action.payload.onClose || (() => {});
      state.title = action.payload.title || "";
      state.children = action.payload.children || null;
      state.data = action.payload.data || null;
      state.className = action.payload.className || "";
      state.header = action.payload.header || undefined;
      state.outerClassName = action.payload.outerClassName || "";
      state.form = action.payload.form ?? initialState.form;
      state.url = action.payload.url || null;
    },
    closeModal(state) {
      state.status = "hide";
    },
    setStepIndex(state, action) {
      state.stepIndex = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
  },
});

export const { openModal, closeModal, setStepIndex, setFormLoading } = uiSlice.actions;
// const selectModal = (state: RootState) => state?.ui;
export const { reducer: uiReducer } = uiSlice;
